import { HintType } from '@sparx/api/apis/sparx/hints/v1/hints';
import { Tooltip } from '@sparx/sparx-design/components';
import { ReactNode, useMemo } from 'react';

export const HintTooltip = ({
  hintType,
  disabled,
  children,
}: {
  hintType: HintType;
  disabled: boolean;
  children: ReactNode;
}) => {
  const tooltipCopy = useMemo(() => {
    switch (hintType) {
      case HintType.HINT_SIMPLIFY_FRACTION:
        return 'Enter the simplified fraction to continue.';
      case HintType.HINT_BEARINGS:
        return 'Enter the bearing with three digits to continue.';
      case HintType.HINT_MONEY:
        return 'Enter your answer with two decimal places to continue.';
      default:
        return 'Follow the hint and correct your answer to continue.';
    }
  }, [hintType]);

  return (
    <Tooltip content={tooltipCopy} position={'top'} disabled={disabled}>
      {children}
    </Tooltip>
  );
};
